var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns",style:(_vm.cssVars)},_vm._l((_vm.slide.columns),function(column,index){return _c('div',{key:index,staticClass:"ratings"},[_c('ul',_vm._l((column.bullets),function(bullet,index){return _c('li',{key:index},[_vm._v(" "+_vm._s(bullet.text)+" ")])}),0)])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }